"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _default2 = require("@/views/product/creatProduct/default");
var _productEnums = require("@/enums/productEnums");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var headTabList = [{
  tit: '商品信息',
  name: '1'
}, {
  tit: '规格库存',
  name: '2'
}, {
  tit: '预约设置',
  name: '5'
}, {
  tit: '商品详情',
  name: '3'
}, {
  tit: '其他设置',
  name: '4'
}];
var _default = exports.default = {
  data: function data() {
    return {
      headTab: [],
      formValidate: Object.assign({}, _default2.defaultObj),
      attrInfo: {},
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      timeCheckGroup: [],
      //自动划分当前选中的元素
      isCustomize: false
    };
  },
  mounted: function mounted() {
    if (this.formValidate.type === 7) {
      this.headTab = headTabList;
    } else {
      this.headTab = headTabList.slice(0, 2).concat(headTabList.slice(3));
    }
  },
  methods: {
    // 获取详情中的规格数据，预约 采集的时候 只有一条规格，这里做处理
    getAttrList: function getAttrList(info, type) {
      if (this.formValidate.type === this.OrderSecondTypeEnum.Reservation) {
        return type === 'copy' && info.attrList.length > 1 ? info.attrList.slice(0, 1) : info.attrList;
      } else {
        return info.attrList;
      }
    },
    // 获取编辑时候的规格数据
    getAttrs: function getAttrs(info) {
      if (info.specType) {
        this.formValidate.attrs = this.formValidate.attrList.map(function (i) {
          return {
            value: i.attributeName,
            detail: i.optionList.map(function (val) {
              return {
                value: val.optionName,
                image: val.image
              };
            }),
            add_pic: i.isShowImage ? 1 : 0
          };
        });
      }
    },
    getData: function getData(res, type) {
      var _this2 = this;
      var info = res;
      this.formValidate.content = '';
      var deliveryMethods = this.formValidate.type === this.OrderSecondTypeEnum.Reservation ? ['3'] : ['1'];
      this.formValidate = _objectSpread(_objectSpread({}, info), {}, {
        image: this.$selfUtil.setDomain(info.image),
        sliderImages: JSON.parse(info.sliderImage),
        cateIds: info.cateId ? info.cateId.split(',') : [],
        // 商品分类id
        sort: info.sort ? info.sort : 0,
        stock: info.stock ? info.stock : 0,
        attrList: info.attrList ? this.getAttrList(info, type) : [],
        attrValueList: info.attrValueList ? info.attrValueList : [],
        isSub: info.isSub ? info.isSub : false,
        content: info.content ? this.$selfUtil.replaceImgSrcHttps(info.content) : '',
        id: info.id ? info.id : 0,
        coupons: info.coupons ? info.coupons : [],
        couponIds: info.couponIds ? info.couponIds : [],
        type: info.type ? info.type : Number(this.$route.params.productType),
        guaranteeIdsList: info.guaranteeIds ? info.guaranteeIds.split(',').map(Number) : [],
        //保障服务
        isPaidMember: info.isPaidMember ? info.isPaidMember : false,
        deliveryMethodList: info.deliveryMethod ? info.deliveryMethod.split(',') : deliveryMethods,
        systemFormId: info.systemFormId ? info.systemFormId : null,
        refundSwitch: type === 'add' ? info.refundSwitch : true,
        supplementReservation: info.supplementReservation ? _objectSpread(_objectSpread({}, info.supplementReservation), {}, {
          reservationDateWeekRangeList: info.supplementReservation.reservationDateWeekRange ? info.supplementReservation.reservationDateWeekRange.split(',').map(Number) : [1, 2, 3, 4, 5, 6, 7]
        }) : {},
        temporaryData: {
          customizeTimeClone: [['', '']],
          // 自定义划分库存
          reservationTime: ['', ''] // 自动划分起止时间
        }
      });
      this.getAttrs(info); // 规格数据
      this.htmlKey++;
      this.labelarr = info.keyword ? info.keyword.split(',') : [];
      if (this.formValidate.categoryId) {
        this.getbrandList();
        this.brandList.push({
          name: '其他',
          id: 0
        });
      }
      if (info.specType) {
        if (info.attrValueList) {
          info.attrValueList.forEach(function (val) {
            val.image = _this2.$selfUtil.setDomain(val.image);
            val.attrValueShow = JSON.parse(val.attrValue);
            val.attr_arr = val.sku.split(',');
            val.brokerage = val.brokerage || 0;
            val.brokerageTwo = val.brokerageTwo || 0;
            val.vipPrice = val.vipPrice || 0;
          });
          this.ManyAttrValue = [].concat(_toConsumableArray(this.oneFormBatch), _toConsumableArray(info.attrValueList));
        } else {
          if (this.formValidate.attrList.length) {
            this.oneFormBatch[0].image = this.$selfUtil.setDomain(info.image);
          }
        }
      } else {
        this.OneattrValue = info.attrValueList;
      }
      if (type !== 'copy' && info.type === this.OrderSecondTypeEnum.Reservation) this.getReservationInfo(info);
      if (this.formValidate.couponIds && this.formValidate.couponIds.length) {
        (0, _product.productCouponListApi)().then(function (res) {
          var ids = _this2.formValidate.couponIds.toString();
          var arr = res;
          var obj = {};
          for (var i in arr) {
            obj[arr[i].id] = arr[i];
          }
          var strArr = ids.split(',');
          var newArr = [];
          var _iterator = _createForOfIteratorHelper(strArr),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (obj[item]) {
                newArr.push(obj[item]);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this2.$set(_this2.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
        });
      }
      var imgs = JSON.parse(info.sliderImage);
      var imgss = [];
      Object.keys(imgs).map(function (i) {
        imgss.push(_this2.$selfUtil.setDomain(imgs[i]));
      });
      this.formValidate.sliderImages = [].concat(imgss);
      if (this.getFileType(this.formValidate.sliderImages[0]) == 'video') {
        //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
        this.$set(this, 'videoLink', this.formValidate.sliderImages[0]);
        this.formValidate.sliderImages.splice(0, 1);
      }
    },
    // 获取选择的时间段
    getTimeCheckGroup: function getTimeCheckGroup() {
      this.timeCheckGroup = [];
      this.timeCheckGroup = this.formValidate.timeSlotAutomatic.filter(function (item) {
        return item.isCheck === 1;
      }).map(function (item) {
        return item.timeSlot;
      });
      this.timeCheckAll = this.timeCheckGroup.length === this.formValidate.timeSlotAutomatic.length;
    },
    // 编辑获取预约商品详情数据
    getReservationInfo: function getReservationInfo(info) {
      //时间段赋值
      if (info.supplementReservation.timeSlotStartEndTime) this.formValidate.temporaryData.reservationTime = info.supplementReservation.timeSlotStartEndTime.split(',');
      //预约商品时段划分类型：1-自动，2-自定义 , 编辑中赋值设置的时间段
      var timeSlotLists = info.timeSlotList.map(function (item) {
        return item.timeSlot;
      });
      if (info.supplementReservation.timeSlotClassifyType === 1) {
        this.formValidate.timeSlotAutomatic = info.timeSlotList;
        this.isCustomize = false;
        this.timeCheckGroup = timeSlotLists;
      } else {
        this.isCustomize = true;
        var formattedTimes = timeSlotLists.map(function (time) {
          return time.split('-');
        });
        this.formValidate.temporaryData.customizeTimeClone = formattedTimes;
        // this.customizeTimeData = timeSlotLists;
      }
      this.getChecked();
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (!tit && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (!tit && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (!tit && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (!tit && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    // 移动关键代码，包含轮播图、规格
    handleDragEnter: function handleDragEnter(e, item, index) {
      if (!this.isDisabled) {
        var _newItems;
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = [];
        newItems = _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        (_newItems = newItems).splice.apply(_newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    }
  }
};